/* eslint-disable */
import React from 'react';
import StatusPill from './StatusPill';

/**
 * DeploymentHome — "My Locations" screen for deployment-role mobile users.
 * Shows only locations the user is scoped to, with shift counts and device stats.
 */
export default function DeploymentHome({ st, account, deploymentLocationIds, onSelectLocation }) {
  const locs = (st.locations || []).filter(l => deploymentLocationIds.includes(l.id));
  const shifts = st.shifts || [];
  const allocs = st.allocations || [];

  return (
    <div style={{ padding: 20, flex: 1, overflowY: 'auto' }}>
      <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--text-subtle)', marginBottom: 10 }}>
        My Locations <span style={{ marginLeft: 8, padding: '1px 6px', background: 'var(--surface-raised)', borderRadius: 999, fontSize: 10, color: 'var(--text-muted)' }}>{locs.length}</span>
      </div>

      {locs.length === 0 && (
        <div style={{ padding: '40px 20px', textAlign: 'center', color: 'var(--text-subtle)' }}>
          <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--text-muted)', marginBottom: 4 }}>No locations assigned</div>
          <div style={{ fontSize: 11 }}>Ask an admin to assign locations to your account.</div>
        </div>
      )}

      {locs.map(loc => {
        const locShifts = shifts.filter(s => s.locationId === loc.id);
        const activeShifts = locShifts.filter(s => s.status === 'active' || (s.status === 'planned' && new Date(s.startAt) <= new Date()));
        const plannedShifts = locShifts.filter(s => s.status === 'planned' && new Date(s.startAt) > new Date());
        const outCount = allocs.filter(a => locShifts.some(s => s.id === a.shiftId) && a.status === 'out').length;
        const stockDevices = (st.devices || []).filter(d => d.location === loc.name || d.location === loc.id || d.assignedLocationId === loc.id);

        const statusLabel = activeShifts.length > 0
          ? `${activeShifts.length} Active`
          : plannedShifts.length > 0
            ? `${plannedShifts.length} Planned`
            : 'No active';
        const statusType = activeShifts.length > 0 ? 'active' : plannedShifts.length > 0 ? 'planned' : 'closed';

        return (
          <div
            key={loc.id}
            onClick={() => onSelectLocation(loc.id)}
            style={{
              background: 'var(--surface-default)', border: '1px solid var(--border-subtle)',
              borderRadius: 14, padding: 16, marginBottom: 10, cursor: 'pointer',
              transition: 'all 0.15s ease',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--text-default)', marginBottom: 4 }}>{loc.name}</div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: 6 }}>
                  {loc.customer || ''}{loc.customer ? ' · ' : ''}{loc.address || ''}
                </div>
              </div>
              <StatusPill status={statusType} label={statusLabel} />
            </div>
            <div style={{
              fontSize: 11, color: 'var(--text-subtle)', marginTop: 10, paddingTop: 10,
              borderTop: '1px solid var(--border-subtle)',
              display: 'flex', justifyContent: 'space-between',
            }}>
              <span>{outCount > 0 ? `${outCount} deployed` : 'None deployed'}</span>
              <span>{stockDevices.length} in stock</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
